/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./style.less";
import Request from "../../utils/request";
import CountDown from './countdown';
import utils from "../../utils/utils";
import { Exposure } from 'shihuo-lib/dist/shihuo-lib';
class PipelineCashBackActNew extends React.Component {
  constructor(props) {
    super(props);
    this.exp = new Exposure(); // 曝光
    this.state = {
      isLogin: false,
      coupon_list: [],
      is_rec: false,
      end_time: '',
      show_toast: false,
      toast_text: '',
      coupons_show: false,
      rulePopupShow: false,
      sharePopupShow: false,
      couponsPopupShow: false
    };
    this.interval = null;
    this.loginInterVal = null;
    this.isShareDisabled = false;
    this.app_version = '';
    this.isShareNativeExit = true;
    this.pageId = utils.getPageId();
  }

  componentDidMount() {
    this.queryLoginStatus();

    this.app_version = utils.getVersion();
    if (utils.isAndroid()) {
      this.isShareNativeExit = utils.SHDiffVersion(this.app_version, '6.67.2');
    } else {
      this.isShareNativeExit = utils.SHDiffVersion(this.app_version, '6.65.0');
    }
  }

  componentWillUnmount() {
    this.loginInterVal && clearInterval(this.loginInterVal);
    this.interval && clearInterval(this.interval);
    this.loginInterVal = null;
    this.interval = null;
  }

  // 轮询判断是否登陆成功
  judgeIsLogin = () => {
    this.loginInterval && clearInterval(this.loginInterval);
    this.loginInterval = setInterval(() => {
      const { isLogin } = this.state;
      if (!isLogin) {
        const CookieUA = utils.getCookie('ua');
        const CookieU = utils.getCookie('u');
        if (CookieUA && CookieU) {
          Promise.all([CookieUA, CookieU]).then(result => {
            this.setState({
              isLogin: result && result[0] && result[1]
            });
          })
        }
      } else {
        this.loginInterval && clearInterval(this.loginInterval);
        this.loginInterval = null;
      }
    }, 500);
  }

  // 登录
  handleLogin = () => {
    if (utils.isShihuo()) {
      // 未登陆，请先进行微信登陆
      if (this.loginInterVal) {
        return;
      }
      if (!utils.isAndroid() && (utils.SHDiffVersion(this.app_version, '6.86.0'))) {
        this.judgeIsLogin();
      } else {
        window.Jockey.send("subscribe", {}, (publishData) => {
          if (publishData.type === "loginSuccess") {
            this.loginInterVal = setInterval(() => {
              this.queryLoginStatus();
            }, 500);
          }
          setTimeout(() => {
            this.loginInterVal && clearInterval(this.loginInterVal);
            this.loginInterVal = null;
          }, 15000);
        });
      }
      window.Jockey.send("action", {
        url: "shihuo://www.shihuo.cn?route=login",
      });
    }
  }

  // 查询登录状态
  queryLoginStatus = () => {
    try {
      Request({
        url: `https://sh-gateway.shihuo.cn/v4/services/sh-user/user/baseInfo?from=${this.pageId}&need_wechat_info=false&complicate=true`,
        method: 'get',
        withCredentials: true,
      }).then(res => {
        const { status, data } = res.data;
        if (status === 0) {
          if (data.user_info && data.user_info.uid) {
            this.loginInterVal && clearInterval(this.loginInterVal);
            this.loginInterVal = null;
            this.setState({
              isLogin: true
            }, () => {
              this.queryCouponsStatus();
            })
          }
        } else {
          this.setState({
            isLogin: false
          }, () => {
            this.queryCouponsStatus();
          })
        }
      })
    } catch (error) {
      this.queryCouponsStatus();
    }
  }
  

  // 查询券状态
  queryCouponsStatus = (showCouponsPopup = false) => {
    const { couponsConfig } = this.props.config;
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/couponInfo?access_token=2322TizdV3pjw8CBsy&activity_code=' + couponsConfig.activityCode,
      method: 'get',
      withCredentials: true,
    }).then(res => {
      const { status, data } = res.data;
      if (status === 0) {
        const { list } = data;
        this.setState({
          coupons_show: true,
          coupon_list: list,
          is_rec: (list && list.length > 0) ? true : false,
          end_time: list && list[0] && list[0].end_time.replace(/-/g, '/'),
          sharePopupShow: false,
          couponsPopupShow: showCouponsPopup
        });
      } else {
        this.setState({
          coupons_show: true,
        });
      }
    })
  }

  // 领取券
  getCashbackCoupons = () => {
    const { couponsConfig } = this.props.config;
    Request({
      url: 'https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/lego_coupon/recCoupon?access_token=2322TizdV3pjw8CBsy',
      method: 'post',
      withCredentials: true,
      data: {
        activity_code: couponsConfig.activityCode,
      },
    }).then(res => {
      const { status, msg } = res.data;
      if (status !== 0) {
        this.setState({
          show_toast: true,
          toast_text: msg,
          sharePopupShow: false
        });
      } else {
        this.queryCouponsStatus(true);
      }
    })
  }

  handleItemClick = () => {
    utils.uploadTrack(this.props, {}, {
      blockName: 'get'
    });

    if (!this.state.isLogin) {
      this.handleLogin();
      return;  
    }

    const { baseConfig } = this.props.config;

    if (baseConfig.needShare === '是') {
      this.setState({
        sharePopupShow: true
      });
    } else {
      this.getCashbackCoupons();
    }
  };

  renderCouponsList = () => {
    const { coupon_list, end_time } = this.state;
    const { couponsConfig } = this.props.config;
    return (
      <div className="coupons-info" style={{backgroundImage: `url(${couponsConfig.couponBackgroundImage})`}}>
        <div 
          className="btn"
          style={{backgroundImage: `url(${couponsConfig.couponBtnImage})`}}
          onClick={() => this.handleUse(couponsConfig.btnHref || 'shihuo://www.shihuo.cn?route=RNProgram&miniId=Shihuo_Category&page=TopIndex', 'toUse')}
        >
          {
            !couponsConfig.noCountDown && end_time && (
              <p className="count-down" style={{color: couponsConfig.countDownTextColor || "#FFF"}}>
                <CountDown end_time={end_time} />
              </p>
            )
          }
        </div>
        <div className="coupon-list">
          <div className="scroll">
            <ul>
              {
                coupon_list && coupon_list.length > 0 && coupon_list.map((item, index) => {
                  return (
                    <div className="coupon-item" key={index}>
                      <img src={utils.formatImgUrl(couponsConfig.couponItemImage, this.props.webpSupport)} alt="" />
                      <div className="content">
                        <p className="money" style={{color: couponsConfig.couponTextColor}}>
                          <span>￥</span>{parseFloat(item.cash_back)}
                        </p>
                        <p className="desc" style={{color: couponsConfig.couponTextColor}}>
                          {parseFloat(item.start_amount) > 0 ? `满${parseFloat(item.start_amount)}可返` : '无门槛'}
                        </p>
                      </div>
                    </div>
                  )
                })
              }
            </ul>
          </div>
        </div>
      </div>
    )
  }

  // 分享
  handleShare = () => {
    if (this.isShareDisabled) {
      return;
    }
    utils.uploadTrack(this.props, {}, {
      blockName: 'share'
    });
    this.isShareDisabled = true;
    const { kouling } = this.props.config.sharePopupConfig;
    if (this.isShareNativeExit) {
      window.Jockey.send("shareNative", {
        type: "text",
        text: kouling
      });
    } else {
      window.Jockey.send("copy", { display: false, content: kouling });
      const wxSchema = "weixin://";
      const iframe = document.createElement("iframe");
      iframe.src = wxSchema;
      iframe.style.display = "none";
      iframe.onload = () => {
        iframe.parentNode.removeChild(iframe);
      };
      document.body.appendChild(iframe);
    }

    setTimeout(() => {
      this.isShareDisabled = false;
      this.getCashbackCoupons();
    }, 2000);
  }

  // 去使用
  handleUse = (url, blockName) => {
    const options = {};
    url && utils.jumpToUrl(this.props.routeParams, url, url, options, -1, this.props, false, {blockName: blockName});
  }

  render() {
    const { is_rec, coupons_show } = this.state;
    const { baseConfig, imgsList } = this.props.config;
    // 判断不同布局方式下的间距取值
    if (baseConfig.sortType === "一行一图") {
      Object.assign(baseConfig, baseConfig.layout_1);
    } else if (baseConfig.sortType === "一行二图") {
      Object.assign(baseConfig, baseConfig.layout_2);
    } else if (baseConfig.sortType === "一行三图") {
      Object.assign(baseConfig, baseConfig.layout_3);
    } else if (baseConfig.sortType === "banner") {
      Object.assign(baseConfig, baseConfig.layout_banner);
    }

    // 转为数字处理，后续参与计算
    baseConfig.imgMarginHorizon = isNaN(Number(baseConfig.imgMarginHorizon))
      ? 0
      : Number(baseConfig.imgMarginHorizon);
    baseConfig.imgMarginVertical = isNaN(Number(baseConfig.imgMarginVertical))
      ? 0
      : Number(baseConfig.imgMarginVertical);

    if (!coupons_show) {
      return null;
    }
    return (
      <div
        className="pipeline-cashBackAct-new"
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`,
        }}
      >
        {
          !is_rec ? (
            <div className="img-list">
              {imgsList.map((item, index) => {
                let rowItemNumber = 3; // 每行排列数量
                if (
                  baseConfig.sortType === "一行一图" ||
                  baseConfig.sortType === "banner"
                ) {
                  rowItemNumber = 1;
                } else if (baseConfig.sortType === "一行二图") {
                  rowItemNumber = 2;
                } else if (baseConfig.sortType === "一行三图") {
                  rowItemNumber = 3;
                }

                const isFirstRow = Boolean(index < rowItemNumber); // 该项是否在首行
                const isLasthRow = Boolean(imgsList.length - index < rowItemNumber); // 该项是否在未行
                const isFirstColumn = Boolean(index % rowItemNumber === 0);
                const isLastColumn = Boolean((index + 1) % rowItemNumber === 0); // 该项是否在未列

                // 计算每个项的宽度
                const totalMargin =
                  (rowItemNumber - 1) * baseConfig.imgMarginHorizon;
                const itemWidth = `calc((100% - ${totalMargin}px) / ${rowItemNumber})`;
                const itemStyle = {
                  width: itemWidth,
                  marginTop: isFirstRow
                    ? "0"
                    : `${baseConfig.imgMarginVertical / 2}px`,
                  marginBottom: isLasthRow
                    ? "0"
                    : `${baseConfig.imgMarginVertical / 2}px`,
                  marginLeft: isFirstColumn
                    ? "0"
                    : `${baseConfig.imgMarginHorizon / 2}px`,
                  marginRight: isLastColumn
                    ? "0"
                    : `${baseConfig.imgMarginHorizon / 2}px`,
                };

                // 判断图片圆角值
                let imgBorderRadius = "6px";
                if (baseConfig.sortType === "banner" || baseConfig.noImgRadius) {
                  // banner图片或者选择不添加圆角情况，值为0
                  imgBorderRadius = "0";
                }

                return (
                  <div
                    className="img-item"
                    key={index}
                    style={itemStyle}
                    onClick={this.handleItemClick.bind(this, item, index)}
                    data-dot={JSON.stringify({
                      id: `${this.props.templatePti}:cashBackAct-get`,
                      name: '返现券活动组件',
                      pageId: this.pageId,
                      biz: JSON.stringify({
                        lego_page_id: this.pageId,
                        component_id: this.props.customAttributes['data-component-id']
                      }),
                      exposekey: 'em.',
                      pti_refer: {
                        pageId: '',
                        root: {
                          id: '',
                          pageId: '',
                          name: '',
                          biz: '',
                        },
                        parent: {
                          id: '',
                          pageId: '',
                          name: '',
                          biz: '',
                        },
                      },
                    })}
                    ref={ele => {
                      if (ele) {
                        this.exp.add({ el: ele });
                      }
                    }}
                  >
                    <img
                      className="img"
                      style={{ borderRadius: imgBorderRadius }}
                      src={utils.formatImgUrl(item.src, this.props.webpSupport)}
                    />
                  </div>
                )
              })}
            </div>
          ) : this.renderCouponsList()
        }
        { this.renderToast() }
        { this.renderRulePopup() }
        { this.renderSharePopup() }
        { this.renderCouponsPopup() }
      </div>
    );
  }

  // 规则弹窗
  renderRulePopup = () => {
    const { rulePopupShow } = this.state;
    if (rulePopupShow) {
      return (
        <Fragment>
          <div className="mask">
            <div className="popup">
              <h3 className="title">返现券使用说明</h3>
              <p>1.该返现券适用于本平台所有品类(包括但不限于鞋、服饰、美妆品类)的商品</p>
              <p>2.该返现券目前只支持在淘宝渠道下单使用</p>
              <p>3.返现券使用流程如下：</p>
              <img src="https://static.shihuocdn.cn/admin/files/20210513/a46af66b3552cc3cc5cbc82929448a96.png" alt="" className="image" />
              <div className="btn" onClick={() => this.closePopup()}>立即使用</div>
              <img src="https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png" alt="" className="close" onClick={() => this.closePopup()} />
            </div>
          </div>
        </Fragment>
      ) 
    } else {
      return null;
    }
  }

  // 分享弹窗
  renderSharePopup = () => {
    const { sharePopupConfig } = this.props.config;
    const { sharePopupShow } = this.state;
    if (sharePopupShow) {
      return (
        <Fragment>
          <div className="mask">
            <div className="share-popup" style={{backgroundImage: `url(${sharePopupConfig.sharePopupImage})`}}>
              <div className="btn" onClick={() => this.handleShare()}>立即分享</div>
              <img src="https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png" alt="" className="close" onClick={() => this.closePopup()} />
            </div>
          </div>
        </Fragment>
      ) 
    } else {
      return null;
    }
  }

  // 券列表弹窗
  renderCouponsPopup = () => {
    const { couponsPopupConfig } = this.props.config;
    const { coupon_list, couponsPopupShow } = this.state;
    if (couponsPopupShow) {
      return (
        <Fragment>
          <div className="mask">
            <div className="coupons-popup" style={{backgroundImage: `url(${couponsPopupConfig.backgroundImage})`}}>
              <h3>恭喜获得</h3>
              <ul className="list">
                {
                  coupon_list && coupon_list.length > 0 && coupon_list.map((item, index) => {
                    return (
                      <li key={`item_${index}`} style={{backgroundImage: `url(${couponsPopupConfig.couponBgImage})`}}>
                        <div className="amount">
                          <p className="cash_back">
                            <span>￥</span>{item.cash_back}
                          </p>
                          <p className="start_amount">{parseFloat(item.start_amount) > 0 ? `满${parseFloat(item.start_amount)}可返` : '无门槛'}</p>
                        </div>
                        <div className="desc">
                          <p className="title">{item.name}</p>
                          <p className="expire-time">
                            有效期至 { item.end_time && item.end_time.split(" ") && item.end_time.split(" ")[0] && item.end_time.split(" ")[0].replace(/-/g, ".")}
                          </p>
                        </div>
                      </li>
                    )
                  })
                }
              </ul>
              <div
                className="btn"
                style={{backgroundImage: `url(${couponsPopupConfig.popupBtnImage})`}}
                onClick={() => this.handleUse(couponsPopupConfig.popupBtnHref, 'dialogToUse')}
              >
                去使用
              </div>
              <img src="https://static.shihuocdn.cn/admin/files/20210513/fa6afe3624dbbdab7e7d5344fdf492a2.png" alt="" className="close" onClick={() => this.closePopup()} />
            </div>
          </div>
        </Fragment>
      ) 
    } else {
      return null;
    }
  }

  // 渲染Toast
  renderToast = () => {
    const { show_toast, toast_text } = this.state;
    if (show_toast) {
      this.interval && clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.setState({
          show_toast: false,
          toast_text: ''
        });
      }, 3000);
      return <p className="toast">{toast_text}</p>;
    } else {
      return null;
    }
  }

  // 查看规则
  handleRuleClick = () => {
    this.setState({
      rulePopupShow: true
    })
  }

  // 关闭弹窗
  closePopup = () => {
    this.setState({
      rulePopupShow: false,
      sharePopupShow: false,
      couponsPopupShow: false
    })
  }
}

PipelineCashBackActNew.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineCashBackActNew };
export default PipelineCashBackActNew;



// WEBPACK FOOTER //
// ./components/pipeline-cashBackActNew/index.js